import type { IssueMessages, Messages } from '../messages.ts';

export const de: Messages = {
  'app.name': 'FreExam Player',
  'app.tagline': 'Übungsprüfungen im JSON-Format vollständig im Browser durchführen.',
  'app.privacy':
    'Ihre Prüfungsdateien und Antworten werden lokal in Ihrem Browser verarbeitet und an keinen Server übertragen.',
  'app.skipToContent': 'Zum Inhalt springen',
  'app.textSizeValue': '{percent} %',

  'import.title': 'Prüfung öffnen',
  'import.instructions': 'Wählen Sie eine .json-Datei auf Ihrem Gerät, oder legen Sie eine hier ab.',
  'import.choose': 'Datei wählen',
  'import.dropHere': 'Datei hier ablegen',
  'import.reading': 'Datei wird gelesen…',
  'import.validating': 'Datei wird geprüft…',
  'import.example': 'Beispielprüfung ansehen',
  'import.formatHelp': 'Was ist eine Prüfungsdatei?',
  'import.downloadTemplate': 'Schema-Vorlage herunterladen',
  'import.downloadTemplateHint': 'Geben Sie sie einer KI zusammen mit Ihrem Material, um eine Prüfungsdatei zu erstellen.',
  'import.again': 'Andere Datei öffnen',

  'exam.loaded': '{title} geladen',
  'exam.questionCount': '{count} Fragen',
  'exam.license': 'Lizenz: {license}',
  'exam.licenseUnknown': 'Keine Lizenz angegeben',
  'exam.source': 'Quelle: {source}',
  'exam.warnings': 'Mit {count} Hinweisen geladen',
  'exam.viewReport': 'Bericht ansehen',

  'report.title': 'Diese Datei kann nicht verwendet werden',
  'report.titleWarnings': 'Die Datei wurde geladen — mit Punkten, die einen Blick wert sind',
  'report.summary': '{errors} Fehler, {warnings} Hinweise',
  'report.download': 'validation-report.json herunterladen',
  'report.copy': 'Bericht kopieren',
  'report.copied': 'Kopiert',
  'report.tryAnother': 'Andere Datei versuchen',
  'report.suppressed': 'und {count} weitere derselben Art',
  'report.question': 'Frage {id}',
  'report.expected': 'Erwartet',
  'report.received': 'Gefunden',
  'report.location': 'Stelle',
  'report.noIssues': 'Keine Probleme gefunden.',
  'report.severity.error': 'Fehler',
  'report.severity.warning': 'Hinweis',
  'report.severity.info': 'Anmerkung',

  'config.title': 'Sitzung einrichten',
  'config.mode': 'Modus',
  'config.mode.exam': 'Prüfung',
  'config.mode.exam.description': 'Mit Zeit; nichts wird vor dem Absenden gezeigt.',
  'config.mode.practice': 'Übung',
  'config.mode.practice.description': 'Ohne Uhr, mit Antworten und Erklärungen unterwegs.',
  'config.mode.custom': 'Eigene',
  'config.mode.custom.description': 'Jede Einstellung selbst wählen.',
  'config.questionCount': 'Anzahl der Fragen',
  'config.all': 'Alle ({count})',
  'config.matching': '{count} Fragen passen zu den Filtern',
  'config.matchingOne': '1 Frage entspricht Ihren Filtern',
  'config.noMatches': 'Keine Frage passt zu diesen Filtern.',
  'config.filters': 'Filter',
  'config.category': 'Kategorie',
  'config.topic': 'Thema',
  'config.difficulty': 'Schwierigkeit',
  'config.type': 'Fragetyp',
  'config.tag': 'Schlagwort',
  'config.seed': 'Startwert',
  'config.seedHelp': 'Derselbe Startwert zieht dieselben Fragen in derselben Reihenfolge.',
  'config.newSeed': 'Neuer Startwert',
  'config.timeLimit': 'Zeitlimit (Minuten)',
  'config.noTimeLimit': 'Kein Zeitlimit',
  'config.shuffleQuestions': 'Fragen mischen',
  'config.shuffleOptions': 'Antwortoptionen mischen',
  'config.immediateFeedback': 'Antwort nach jeder Frage zeigen',
  'config.allowBack': 'Zurückgehen erlauben',
  'config.allowChange': 'Antworten ändern erlauben',
  'config.start': 'Starten',
  'config.back': 'Zurück',
  'config.candidateName': 'Ihr Name',
  'config.candidateNamePlaceholder': 'Optional',
  'config.candidateNameHelp':
    'Wird während der Prüfung angezeigt und in die exportierten Ergebnisse geschrieben. Bleibt auf Ihrem Gerät.',
  'config.timer': 'Zeitnahme',
  'config.timerOn': 'Zeit messen',
  'config.useRange': 'Nur ein Fragenbereich',
  'config.rangeFrom': 'Von',
  'config.rangeTo': 'Bis',
  'config.rangeHelp': 'Nummeriert wie in der Datei, 1 bis {total}.',
  'config.weakest': 'Was Sie falsch hatten',
  'config.onlyIncorrect': 'Nur Fragen, die ich falsch beantwortet habe ({count} verfügbar)',
  'config.incorrectAtLeast': 'Mindestens so oft',
  'config.device': 'Dieses Gerät',
  'config.remember': 'Fortschritt auf diesem Gerät merken',
  'config.rememberHelp':
    'Merkt sich, welche Fragen Sie falsch beantworten, und erlaubt es, eine Sitzung zu speichern und später fortzusetzen. Bleibt in diesem Browser und wird nie hochgeladen. Aus, bis Sie es einschalten.',
  'config.remembered': '{count} Fragen sind als falsch beantwortet gespeichert.',
  'config.forget': 'Alles auf diesem Gerät löschen',

  'difficulty.easy': 'Leicht',
  'difficulty.medium': 'Mittel',
  'difficulty.hard': 'Schwer',

  'type.single-choice': 'Einfachauswahl',
  'type.multiple-choice': 'Mehrfachauswahl',
  'type.matching': 'Zuordnung',
  'type.ordering': 'Reihenfolge',
  'type.text': 'Freitext',

  'session.question': 'Frage {position} von {total}',
  'session.previous': 'Zurück',
  'session.next': 'Weiter',
  'session.mark': 'Zur Überprüfung markieren',
  'session.marked': 'Zur Überprüfung markiert',
  'session.report': 'Problem melden',
  'session.submit': 'Absenden',
  'session.navigator': 'Fragen',
  'session.timeRemaining': 'Verbleibende Zeit',
  'session.timeUp': 'Zeit ist um',
  'session.paused': 'Pausiert',
  'session.selectCount': 'Wählen Sie {count}',
  'session.selectRange': 'Wählen Sie zwischen {min} und {max}',
  'session.answerHere': 'Ihre Antwort',
  'session.checkAnswer': 'Antwort prüfen',
  'session.correct': 'Richtig',
  'session.incorrect': 'Nicht richtig',
  'session.explanation': 'Erklärung',
  'session.references': 'Quellen',
  'session.status.answered': 'beantwortet',
  'session.status.unanswered': 'nicht beantwortet',
  'session.status.marked': 'zur Überprüfung markiert',
  'session.status.current': 'aktuelle Frage',
  'session.moveUp': 'Nach oben',
  'session.moveDown': 'Nach unten',
  'session.position': 'Position {position}',
  'session.matchWith': 'Zuordnen zu',
  'session.chooseTarget': 'Wählen…',
  'session.sourceNumber': 'Datei: Frage {number}',
  'session.pause': 'Pause',
  'session.resume': 'Fortsetzen',
  'session.pausedHelp': 'Die Uhr steht und die Fragen sind ausgeblendet.',
  'session.save': 'Sitzung speichern',
  'session.saved': 'Sitzung auf diesem Gerät gespeichert.',
  'session.saveFailed': 'Die Sitzung konnte auf diesem Gerät nicht gespeichert werden.',
  'session.review': 'Durchsehen',
  'session.reviewAll': 'Alle ({count})',
  'session.reviewMarked': 'Markiert ({count})',
  'session.reviewUnanswered': 'Offen ({count})',
  'session.goToNext': 'Zur nächsten',
  'session.reviewEmpty': 'Nichts vorhanden.',

  'note.add': 'Notiz hinzufügen',
  'note.label': 'Ihre Notiz zu dieser Frage',
  'note.placeholder': 'Was unklar war, was nachzuschlagen ist, was Sie behalten möchten.',
  'note.help': 'Notizen bleiben auf Ihrem Gerät. Am Ende lesen Sie sie alle zusammen.',
  'note.remaining': 'Noch {count} Zeichen.',
  'note.summaryTitle': 'Ihre Notizen ({count})',
  'note.export': 'Notizen exportieren',
  'note.includeQuestions': 'Die Fragen mitnehmen, um damit zu lernen',
  'note.exportHelp':
    'Eine lesbare Markdown-Datei mit Ihren Notizen und den Nummern der zugehörigen Fragen. Die Fragen selbst enthält sie nicht.',
  'note.exportHelpWithQuestions':
    'Eine lesbare Markdown-Datei mit jeder notierten Frage, den Optionen wie Sie sie gesehen haben, Ihrer Antwort, der richtigen Antwort und der Erklärung. Sie enthält den Prüfungsinhalt — behandeln Sie sie so, wie es die Lizenz der Prüfung verlangt.',

  'controls.textSize': 'Schriftgröße',
  'controls.textSize.description': 'Die Fragen größer oder kleiner darstellen.',
  'controls.language': 'Sprache',
  'controls.language.description': 'Die Sprache dieser Oberfläche, nicht die der Prüfung.',
  'controls.focus': 'Fokusmodus',
  'controls.focus.description': 'Nur die aktuelle Frage zeigen.',
  'controls.theme': 'Erscheinungsbild',
  'controls.theme.description': 'Hell, dunkel, oder wie Ihr Gerät es einstellt.',
  'controls.theme.system': 'Gerät folgen',
  'controls.theme.light': 'Hell',
  'controls.theme.dark': 'Dunkel',

  'correct.open': 'Diese Frage korrigieren',
  'correct.title': 'Was dort stehen sollte',
  'correct.help':
    'Das sieht nur Sie. Am Ende bietet die Ergebnisseite eine korrigierte Kopie der Prüfung an, die Sie an die Autorschaft schicken können.',
  'correct.reason': 'Was falsch ist',
  'correct.reason.incorrect-answer': 'Die markierte Antwort ist falsch',
  'correct.reason.incorrect-explanation': 'Die Erklärung ist falsch',
  'correct.reason.typo': 'Ein Tippfehler',
  'correct.reason.media-description': 'Das Bild braucht eine Beschreibung',
  'correct.reason.ambiguous-question': 'Die Frage ist mehrdeutig',
  'correct.reason.outdated-content': 'Der Inhalt ist veraltet',
  'correct.reason.conversion-error': 'Bei der Umwandlung ist etwas verloren gegangen',
  'correct.reason.translation-error': 'Die Übersetzung ist falsch',
  'correct.reason.other': 'Etwas anderes',
  'correct.answer': 'Die richtige Antwort',
  'correct.optionText': 'Der Wortlaut jeder Option',
  'correct.explanation': 'Die Erklärung',
  'correct.mediaDescription': 'Was das Bild zeigte: {alt}',
  'correct.note': 'Was die Autorschaft sonst wissen sollte',
  'correct.discard': 'Diese Korrektur verwerfen',
  'correct.export': 'Korrigierte Prüfung exportieren',
  'correct.exportHelp':
    'Eine vollständige Prüfungsdatei mit Ihren Korrekturen, die festhält, woher sie stammt und was Sie geändert haben. Sie enthält den Prüfungsinhalt — die Lizenz der Prüfung bestimmt, was Sie damit tun dürfen.',

  'update.available': 'Eine neue Version des Players ist bereit.',
  'update.apply': 'Jetzt neu laden',
  'update.later': 'Später',

  'focus.open': 'Fokus',
  'focus.title': 'Fokusmodus',
  'focus.exit': 'Schließen',

  'calculator.title': 'Rechner',
  'calculator.close': 'Schließen',
  'calculator.error': 'Division durch null nicht möglich',

  'resume.title': 'Es gibt eine gespeicherte Sitzung für diese Prüfung',
  'resume.draftTitle': 'Sie waren mitten in dieser Prüfung',
  'resume.detail': '{answered} von {total} Fragen beantwortet.',
  'resume.continue': 'Fortsetzen',
  'resume.discard': 'Verwerfen',

  'media.wasImage': 'Die ursprüngliche Frage enthielt ein Bild.',
  'media.unavailable': 'Das Bild ist in dieser Datei nicht enthalten.',
  'media.remote': 'Das Bild liegt anderswo und wird nicht automatisch geladen.',
  'media.description': 'Beschreibung',

  'submit.title': 'Antworten absenden?',
  'submit.complete': 'Sie haben alle Fragen beantwortet.',
  'submit.incomplete': '{count} Fragen sind nicht beantwortet.',
  'submit.marked': '{count} Fragen sind zur Überprüfung markiert.',
  'submit.confirm': 'Absenden',
  'submit.cancel': 'Weitermachen',

  'results.title': 'Ergebnis',
  'results.score': '{percent} %',
  'results.scoreOf': '{raw} von {max} Punkten',
  'results.passed': 'Bestanden',
  'results.failed': 'Nicht bestanden',
  'results.correct': 'Richtig',
  'results.incorrect': 'Falsch',
  'results.unanswered': 'Nicht beantwortet',
  'results.partial': 'Teilweise',
  'results.ungraded': 'Nicht automatisch bewertet',
  'results.ungradedHelp':
    'Das sind Freitextantworten, die die App nicht bewerten kann. Sehen Sie sie durch und entscheiden Sie selbst.',
  'results.duration': 'Benötigte Zeit',
  'results.averagePerQuestion': 'Durchschnitt pro Frage',
  'results.byCategory': 'Nach Kategorie',
  'results.byDifficulty': 'Nach Schwierigkeit',
  'results.byType': 'Nach Fragetyp',
  'results.byTag': 'Nach Schlagwort',
  'results.review': 'Antworten durchsehen',
  'results.export': 'Ergebnis exportieren',
  'results.newSession': 'Neue Sitzung',
  'results.markedCount': 'Zur Überprüfung markiert',
  'results.yourAnswer': 'Ihre Antwort',
  'results.correctAnswer': 'Richtige Antwort',
  'results.markCorrect': 'Das war richtig',
  'results.markIncorrect': 'Das war falsch',
  'results.noAnswer': 'Keine Antwort gegeben',

  'reportQuestion.title': 'Problem mit dieser Frage melden',
  'reportQuestion.help':
    'Das bleibt auf Ihrem Gerät. Es wird mit Ihrem exportierten Ergebnis gespeichert und kann für eine korrigierte Fassung der Prüfung genutzt werden.',
  'reportQuestion.reason.incorrect-answer': 'Die markierte Antwort ist falsch',
  'reportQuestion.reason.ambiguous-question': 'Die Frage ist mehrdeutig',
  'reportQuestion.reason.incorrect-explanation': 'Die Erklärung ist falsch',
  'reportQuestion.reason.outdated-content': 'Der Inhalt ist veraltet',
  'reportQuestion.reason.conversion-error': 'Bei der Konvertierung ging etwas verloren',
  'reportQuestion.reason.translation-error': 'Die Übersetzung ist falsch',
  'reportQuestion.reason.other': 'Etwas anderes',
  'reportQuestion.comment': 'Noch etwas? (optional)',
  'reportQuestion.save': 'Speichern',
  'reportQuestion.cancel': 'Abbrechen',
  'reportQuestion.saved': 'Meldung gespeichert',

  'common.close': 'Schließen',
  'common.cancel': 'Abbrechen',
  'common.of': 'von',
  'common.minutes': '{count} Min.',
  'common.seconds': '{count} s',
};

export const deIssues: IssueMessages = {
  FILE_EMPTY: 'Die Datei ist leer.',
  FILE_TOO_LARGE: 'Die Datei ist größer, als diese App öffnet ({expected}).',
  FILE_UNSUPPORTED_EXTENSION: 'Es können nur {expected}-Dateien geöffnet werden.',
  FILE_READ_FAILED: 'Die Datei konnte nicht gelesen werden. Vielleicht wurde sie verschoben.',
  FILE_NOT_UTF8: 'Die Datei ist kein gültiger UTF-8-Text. Speichern Sie sie erneut als UTF-8.',

  SEC_DEPTH_EXCEEDED: 'Die Datei ist zu tief verschachtelt für eine Prüfung.',
  SEC_NODES_EXCEEDED: 'Die Datei enthält weit mehr Daten, als eine Prüfung haben sollte.',
  SEC_PROTO_POLLUTION_KEY: 'Unsichere Schlüssel ({received}) wurden beim Lesen entfernt.',
  SEC_UNSAFE_URL: 'Eine URL in der Datei verwendet ein nicht erlaubtes Schema.',
  SEC_MEDIA_NOT_ALLOWED_TYPE: 'Ein eingebettetes Bild hat ein nicht erlaubtes Format.',
  SEC_MEDIA_TYPE_MISMATCH: 'Ein eingebettetes Bild passt nicht zum angegebenen Typ ({received}).',
  SEC_MEDIA_INVALID_BASE64: 'Ein eingebettetes Bild ist kein gültiges Base64.',
  SEC_MEDIA_TOO_LARGE: 'Ein eingebettetes Bild ist größer als erlaubt.',
  SEC_MEDIA_DIMENSIONS_TOO_LARGE:
    'Ein eingebettetes Bild gibt mehr Pixel an, als sich gefahrlos zeichnen lassen. Die Datei ist klein, das Dekodieren wäre es nicht.',
  SEC_MEDIA_HEADER_UNREADABLE:
    'Ein eingebettetes Bild hat einen Kopf, den dieser Player nicht lesen kann; seine Größe lässt sich vor dem Dekodieren nicht prüfen.',

  JSON_SYNTAX_ERROR: 'Die Datei ist kein gültiges JSON (Zeile {line}, Spalte {column}).',
  JSON_ROOT_NOT_OBJECT: 'Eine Prüfungsdatei muss ein JSON-Objekt sein, dies ist {received}.',

  DETECT_MISSING_KIND: 'Die Datei sagt nicht, was sie ist. Fügen Sie "kind": "exam" hinzu.',
  DETECT_UNKNOWN_KIND: 'Diesen Dateityp kennt die App nicht ({received}).',
  DETECT_WRONG_KIND: 'Dies ist eine Ergebnisdatei, keine Prüfung.',
  DETECT_INVALID_VERSION: 'schemaVersion ist keine Versionsnummer ({received}).',
  DETECT_UNSUPPORTED_MAJOR: 'Diese Datei nutzt Format {received}; die App versteht {expected}.',
  DETECT_NEWER_MINOR:
    'Diese Datei wurde für eine neuere Version des Formats geschrieben ({received}). Unbekanntes wird ignoriert.',

  SCHEMA_REQUIRED_PROPERTY_MISSING: 'Es fehlt {expected}.',
  SCHEMA_UNKNOWN_PROPERTY: 'Unerwartete Eigenschaft {received}.',
  SCHEMA_WRONG_TYPE: 'Erwartet {expected}, gefunden {received}.',
  SCHEMA_VALUE_NOT_ALLOWED: 'Erwartet {expected}, gefunden {received}.',
  SCHEMA_PATTERN_MISMATCH: 'Erwartet {expected}, gefunden {received}.',
  SCHEMA_TEXT_LENGTH_OUT_OF_RANGE: 'Erwartet {expected}, gefunden {received}.',
  SCHEMA_ARRAY_LENGTH_OUT_OF_RANGE: 'Erwartet {expected}, gefunden {received}.',
  SCHEMA_DUPLICATE_ITEMS: 'Erwartet {expected}: {received}.',
  SCHEMA_NUMBER_OUT_OF_RANGE: 'Erwartet eine Zahl {expected}, gefunden {received}.',
  SCHEMA_FORBIDDEN_COMBINATION: 'Diese Felder lassen sich so nicht kombinieren.',
  SCHEMA_CONSTRAINT_VIOLATED: 'Dieser Wert erfüllt das Schema nicht.',
  SCHEMA_CONTENT_HASH_NOT_AUTHORABLE:
    'contentHash gehört nicht in die Datei: er wird aus der Datei selbst berechnet. Bitte entfernen.',

  MIGRATION_NO_PATH: 'Diese Datei lässt sich nicht von {expected} aus konvertieren.',
  MIGRATION_FIELD_DROPPED: 'Beim Konvertieren wurde ein Feld verworfen.',
  MIGRATION_PRODUCED_INVALID_DOCUMENT:
    'Die Konvertierung ergab etwas Ungültiges. Das ist ein Fehler der App, nicht Ihrer Datei.',

  SEM_DUPLICATE_QUESTION_ID: 'Zwei Fragen haben dieselbe id: {received}.',
  SEM_DUPLICATE_OPTION_ID: 'Zwei Optionen dieser Frage haben dieselbe id: {received}.',
  SEM_UNKNOWN_CORRECT_OPTION: 'Die richtige Antwort {received} ist keine der Optionen.',
  SEM_UNKNOWN_TAXONOMY_REF: 'Die Kategorie {received} ist in der Taxonomie nicht deklariert.',
  SEM_TAXONOMY_NOT_DECLARED:
    'Fragen sind klassifiziert, aber die Prüfung deklariert keine Taxonomie; Kategorien lassen sich nicht prüfen.',
  SEM_TAXONOMY_UNUSED_NODE: 'Eine deklarierte Kategorie oder ein Thema wird von keiner Frage genutzt.',

  SEM_MC_SELECTION_MISMATCH: 'Die Zahl zu wählender Antworten passt nicht zum Lösungsschlüssel.',
  SEM_MC_ALL_OPTIONS_CORRECT: 'Alle Optionen sind als richtig markiert.',
  SEM_MC_SINGLE_CORRECT_ANSWER: 'Nur eine Antwort ist richtig; das könnte Einfachauswahl sein.',
  SEM_MATCHING_ITEM_WITHOUT_PAIR: 'Ein Element hat keine Antwort: {received}.',
  SEM_MATCHING_DUPLICATE_ITEM_PAIR: 'Ein Element ist mehrfach zugeordnet: {received}.',
  SEM_MATCHING_TARGET_REUSED: 'Ein Ziel wird mehrfach verwendet: {received}.',
  SEM_MATCHING_UNKNOWN_REF: 'Der Lösungsschlüssel verweist auf etwas, das es nicht gibt: {received}.',
  SEM_MATCHING_NO_DISTRACTOR: 'Es gibt so viele Ziele wie Elemente; das letzte Paar ist geschenkt.',
  SEM_ORDERING_NOT_PERMUTATION: 'Die richtige Reihenfolge listet nicht jedes Element genau einmal.',
  SEM_ORDERING_IDENTITY: 'Die Elemente stehen bereits in der richtigen Reihenfolge.',
  SEM_TEXT_AUTO_WITHOUT_ACCEPTED: 'Diese Frage ist automatisch bewertet, hat aber keine Antworten.',
  SEM_TEXT_ACCEPTED_COLLIDES: 'Zwei akzeptierte Antworten sind nach der Normalisierung gleich.',
  SEM_TEXT_SELF_WITHOUT_SAMPLE: 'Selbstbewertete Frage ohne Vergleichsantwort.',

  SEM_MEDIA_DUPLICATE_ID: 'Zwei Bilder dieser Frage haben dieselbe id.',
  SEM_MEDIA_MISSING_ALT: 'Ein Bild hat keinen Alternativtext.',
  SEM_MEDIA_ESSENTIAL_WITHOUT_DESCRIPTION:
    'Die Frage hängt an einem Bild ohne Beschreibung und ist ohne dieses nicht beantwortbar.',
  SEM_MEDIA_UNRESOLVABLE: 'Ein Bild wird nicht gezeigt ({received}); die Beschreibung wird genutzt.',
  SEM_MEDIA_TOTAL_SIZE_EXCEEDED: 'Die eingebetteten Bilder ergeben mehr als erlaubt ({received}).',

  SEM_UNSAFE_URL: 'Ein Link ist keine einfache https-URL ({received}).',
  SEM_EXPLANATION_MISSING: 'Diese Frage hat keine Erklärung.',
  SEM_OPTION_TEXT_DUPLICATE: 'Zwei Optionen sagen dasselbe.',
  SEM_OPTION_LOOKS_LIKE_LETTER:
    'Eine Options-id sieht aus wie ein Anzeigebuchstabe ({received}); nutzen Sie eine stabile id.',
  SEM_PROMPT_CONTAINS_MARKUP: 'Dieser Text enthält Markup, das wörtlich angezeigt wird.',
  SEM_PROMPT_REFERENCES_MISSING_IMAGE: 'Die Frage erwähnt ein Bild, deklariert aber keines.',
  SEM_LANGUAGE_MISMATCH: 'Diese Frage ist in einer anderen Sprache als die Prüfung.',
  SEM_LICENSE_NOT_SPDX: 'Die Lizenz {received} ist kein bekannter SPDX-Bezeichner.',
  SEM_LICENSE_NOT_DECLARED: 'Die Prüfung gibt keine Lizenz an.',
  SEM_INVALID_DATE: 'Ein Datum existiert nicht: {received}.',
};

export const deHints: Record<string, string> = {
  FILE_READ_FAILED_HINT_RESELECT: 'Wählen Sie die Datei erneut.',
  FILE_NOT_UTF8_HINT_RESAVE: 'In einem Texteditor öffnen und als UTF-8 speichern.',
  JSON_SYNTAX_HINT_TRUNCATED: 'Die Datei wirkt abgeschnitten — prüfen Sie den Download.',
  DETECT_MISSING_KIND_HINT_ADD: 'Fügen Sie "kind": "exam" als erste Eigenschaft hinzu.',
  DETECT_WRONG_KIND_HINT_SESSION_FILE: 'Öffnen Sie sie über die Ergebnisseite.',
  DETECT_UNSUPPORTED_MAJOR_HINT_UPDATE_APP: 'Aktualisieren Sie die App.',
  DETECT_UNSUPPORTED_MAJOR_HINT_TOO_OLD: 'Diese Formatversion wird nicht mehr unterstützt.',
  SCHEMA_CONTENT_HASH_HINT_REMOVE: 'Löschen Sie die Eigenschaft contentHash.',
  SCHEMA_UNKNOWN_PROPERTY_HINT_TYPO: 'Prüfen Sie die Schreibweise im Schema.',
  SEM_UNKNOWN_CORRECT_OPTION_HINT: 'Korrigieren Sie den Lösungsschlüssel oder ergänzen Sie die Option.',
  SEM_UNKNOWN_TAXONOMY_REF_HINT_DID_YOU_MEAN: 'Meinten Sie {suggestion}?',
  SEM_TAXONOMY_NOT_DECLARED_HINT: 'Deklarieren Sie exam.taxonomy, damit Kategorien geprüft werden.',
  SEM_MC_ALL_OPTIONS_CORRECT_HINT: 'Prüfen Sie den Lösungsschlüssel — meist ein Konvertierungsfehler.',
  SEM_ORDERING_IDENTITY_HINT: 'Listen Sie die Elemente in anderer Reihenfolge als die Lösung.',
  SEM_TEXT_SELF_WITHOUT_SAMPLE_HINT: 'Ergänzen Sie eine sampleAnswer als Vergleich.',
  SEM_MEDIA_ESSENTIAL_WITHOUT_DESCRIPTION_HINT:
    'Beschreiben Sie das Bild so genau, dass man danach antworten kann.',
  SEM_MEDIA_UNRESOLVABLE_HINT_REMOTE: 'Betten Sie das Bild ein, oder verlassen Sie sich auf die Beschreibung.',
  SEM_MEDIA_UNRESOLVABLE_HINT_PACKAGE: 'Prüfungspakete werden noch nicht unterstützt.',
  SEM_OPTION_LOOKS_LIKE_LETTER_HINT: 'Nutzen Sie ids wie "opt-1"; Buchstaben vergibt der Player.',
  SEM_PROMPT_CONTAINS_MARKUP_HINT: 'Schema 1.0 kennt kein Markdown und kein HTML — reiner Text.',
  SEM_PROMPT_REFERENCES_MISSING_IMAGE_HINT: 'Ergänzen Sie einen Medieneintrag mit Beschreibung.',
  SEM_LICENSE_NOT_DECLARED_HINT: 'Ergänzen Sie exam.license, etwa "CC-BY-4.0".',
};
